window.globalSearch = function(search_val) {
    window.location.href = "/search?q="+search_val;
}
